// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Pr95","rootCenter":"LoadMoreObserver_rootCenter__39VFI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3ycn2"};